import { useEffect, useRef } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import CanvasIcon from "./CanvasIcon";
import { ICON_PATHS } from "./step-look";

const JourneyOverlay = ({
  open,
  title,
  summary,
  openLabel,
  closeLabel,
  onOpenSelected,
  onClose,
  children,
}) => {
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (event) => {
      if (event.key === "Escape") onCloseRef.current();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open]);

  return (
    <div
      className={classNames("canvas-journey", { "canvas-journey--open": open })}
      role="dialog"
      aria-modal={open ? "true" : undefined}
      aria-label={title}
      aria-hidden={open ? undefined : "true"}
      inert={open ? undefined : ""}
    >
      <button
        type="button"
        tabIndex={-1}
        className="canvas-journey__backdrop"
        aria-label={closeLabel}
        onClick={onClose}
      />
      <div className="canvas-journey__panel">
        <div className="canvas-journey__head">
          <div className="canvas-journey__heading">
            <h2 className="canvas-journey__title">{title}</h2>
            <span className="canvas-journey__summary">{summary}</span>
          </div>
          {openLabel ? (
            <button
              type="button"
              className="canvas-journey__open"
              onClick={onOpenSelected}
            >
              {openLabel}
            </button>
          ) : null}
          <button
            type="button"
            className="canvas-journey__close"
            aria-label={closeLabel}
            title={closeLabel}
            onClick={onClose}
          >
            <CanvasIcon path={ICON_PATHS.close} size={16} strokeWidth={2.4} />
          </button>
        </div>
        <div className="canvas-journey__graph">{children}</div>
      </div>
    </div>
  );
};

JourneyOverlay.propTypes = {
  open: PropTypes.bool,
  title: PropTypes.string,
  summary: PropTypes.string,
  openLabel: PropTypes.string,
  closeLabel: PropTypes.string,
  onOpenSelected: PropTypes.func,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node,
};

JourneyOverlay.defaultProps = {
  open: false,
  title: "",
  summary: "",
  openLabel: "",
  closeLabel: "",
  onOpenSelected: () => undefined,
  children: null,
};

export default JourneyOverlay;
